import { Instagram, Youtube, Music2, Send, Globe } from "lucide-react";
import { useContent } from "@/context/ContentContext";

const ICONS = { instagram: Instagram, youtube: Youtube, music: Music2, send: Send, globe: Globe };

export function PlatformIcon({ icon, className = "h-5 w-5" }) {
  const Ico = ICONS[icon] || Globe;
  return <Ico className={className} />;
}

const QUALITY = {
  economy: { key: "badge.quality.economy", def: "ÉCONOMIE", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  standard: { key: "badge.quality.standard", def: "STANDARD", cls: "bg-blue-50 text-blue-600 border-blue-200" },
  premium: { key: "badge.quality.premium", def: "PREMIUM", cls: "bg-amber-50 text-amber-700 border-amber-200" },
};

export function QualityBadge({ level }) {
  const { t } = useContent();
  const q = QUALITY[level] || QUALITY.standard;
  return (
    <span data-testid={`quality-badge-${level}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[10px] font-semibold tracking-wide ${q.cls}`}>
      {t(q.key, q.def)}
    </span>
  );
}

const STATUS = {
  pending: { key: "badge.status.pending", def: "En attente", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  processing: { key: "badge.status.processing", def: "En traitement", cls: "bg-indigo-50 text-indigo-600 border-indigo-200" },
  in_progress: { key: "badge.status.in_progress", def: "En cours", cls: "bg-blue-50 text-blue-600 border-blue-200" },
  completed: { key: "badge.status.completed", def: "Terminée", cls: "bg-emerald-50 text-emerald-600 border-emerald-200" },
  partial: { key: "badge.status.partial", def: "Partielle", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  cancelled: { key: "badge.status.cancelled", def: "Annulée", cls: "bg-slate-100 text-slate-500 border-slate-200" },
  failed: { key: "badge.status.failed", def: "Échouée", cls: "bg-red-50 text-red-600 border-red-200" },
  refunded: { key: "badge.status.refunded", def: "Remboursée", cls: "bg-purple-50 text-purple-600 border-purple-200" },
  awaiting_retry: { key: "badge.status.awaiting_retry", def: "En attente de nouvelle tentative", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  open: { key: "badge.status.open", def: "Ouvert", cls: "bg-blue-50 text-blue-600 border-blue-200" },
  answered: { key: "badge.status.answered", def: "Répondu", cls: "bg-emerald-50 text-emerald-600 border-emerald-200" },
  resolved: { key: "badge.status.resolved", def: "Résolu", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  closed: { key: "badge.status.closed", def: "Fermé", cls: "bg-slate-100 text-slate-500 border-slate-200" },
  active: { key: "badge.status.active", def: "Actif", cls: "bg-emerald-50 text-emerald-600 border-emerald-200" },
  suspended: { key: "badge.status.suspended", def: "Suspendu", cls: "bg-red-50 text-red-600 border-red-200" },
  completed_pay: { key: "badge.status.completed_pay", def: "Complété", cls: "bg-emerald-50 text-emerald-600 border-emerald-200" },
};

export function StatusBadge({ status }) {
  const { t } = useContent();
  const s = STATUS[status];
  return (
    <span data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${s ? s.cls : "bg-slate-100 text-slate-600 border-slate-200"}`}>
      {s ? t(s.key, s.def) : status}
    </span>
  );
}
